import { EpRadioGroup } from '../../../../components/EpRadioGroup';
import { useFormContext, useWatch } from 'react-hook-form';
import { EpErrorMessage, EpRadioButton } from '../../components';
import { useTranslation as t } from '../../../../hooks/useTranslation';

const ThereWasNegativeDemonstration = ({
  translations,
}: {
  translations: unknown;
}) => {
  const patientOrFamilyKnow = useWatch({ name: 'patientOrFamilyKnow' });
  const controller = 'thereWasNegativeDemonstration';
  const { formState: { errors } } = useFormContext();

  if (
    patientOrFamilyKnow.inputValue &&
    patientOrFamilyKnow.inputValue === 'true'
  ) {
    return (
      <>
        <EpRadioGroup
          legend={t(translations, 'Was there a negative manifestation?')}
        >
          <EpRadioButton
            radioId={`EpRadio__yes`}
            radioValue={'true'}
            radioName={controller}
            radioLabel={t(translations, 'Yes')}
            required={true}
            errorMessage={t(translations, '* Required Fied')}
            radioWithError={!!errors[controller]}
          />

          <EpRadioButton
            radioId={`EpRadio__no`}
            radioValue={'false'}
            radioName={controller}
            radioLabel={t(translations, 'No')}
            required={true}
            errorMessage={t(translations, '* Required Fied')}
            radioWithError={!!errors[controller]}
          />
        </EpRadioGroup>
        <EpErrorMessage inputName={controller} />
      </>
    );
  }

  return null;
};

export default ThereWasNegativeDemonstration;
